export default __webpack_public_path__ + "static/media/Sume_UlisesTrevino.8aa3a131.png";